import { createSelector } from 'reselect';
import { AnyStateWithRefund } from '../types';
import { groupRefundServicesByPassenger, groupServicesByType } from '../../../../../RefundSummary/utils';
import { RefundServices } from '../../../../../RefundSummary/types';
import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';

export const getGdsServicesRefundInfoState = (state: AnyStateWithRefund) => state.refund.gdsServicesRefundInfo;

export const getGdsServicesRefundByType = createSelector(getGdsServicesRefundInfoState, services => {
	if (!!services?.length) {
		const servicesByType = groupServicesByType(services);

		const refundServicesByType = new Map<OrderAdditionalServiceGdsServiceServiceType, RefundServices>();

		servicesByType.forEach((value, key) => {
			refundServicesByType.set(key, groupRefundServicesByPassenger(value));
		});

		return refundServicesByType;
	}

	return null;
});

export const getIsAnySeatsToRefund = createSelector(
	getGdsServicesRefundByType,
	gdsServicesRefundByType => !!gdsServicesRefundByType?.get(OrderAdditionalServiceGdsServiceServiceType.Seat)
);
